"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderStatus = void 0;
var OrderStatus;
(function (OrderStatus) {
    OrderStatus["NEW"] = "NEW";
    OrderStatus["SCHEDULED"] = "SCHEDULED";
    OrderStatus["NOW_IN_DELIVERY"] = "NOW_IN_DELIVERY";
    OrderStatus["DELIVERED"] = "DELIVERED";
    OrderStatus["CLOSED"] = "CLOSED";
    OrderStatus["CANCELED"] = "CANCELED";
})(OrderStatus || (exports.OrderStatus = OrderStatus = {}));
//# sourceMappingURL=order.js.map